import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RequestMethod} from "@angular/http";
import {RequestConfig, RestResponse} from "../../../../shared/rest/rest.request";
import {Categoria} from "../+categorias/categorias.service";
import {CustomHttp} from "../../../../common/http/custom.http";
import {PageImpl} from "../../../../common/http/PageImpl";

@Injectable()
export class CamposService {
    private CREATE_CODE = new RequestConfig("TCE", "application/json", true, RequestMethod.Post, "/tickets/fields");
    private EDIT_CODE = new RequestConfig("TCE", "application/json", true, RequestMethod.Put, "/tickets/fields/{fieldId}");
    private DELETE_CODE = new RequestConfig("TCE", "application/json", true, RequestMethod.Delete, "/tickets/fields/{fieldId}");
    private GET_CODE = new RequestConfig("TCE", "application/json", true, RequestMethod.Get, "/tickets/fields/{fieldId}");
    private GET_PAGE = new RequestConfig("TCE", "application/json", true, RequestMethod.Get, "/tickets/fields");
    private GET_BY_CATEGORY = new RequestConfig("TCE", "application/json", true, RequestMethod.Get, "/tickets/fields/byCategory");

    public options: any = [
        {code: "text", value: "Texto"},
        {code: "number", value: "Número"},
        {code: "shortDate", value: "Fecha Corta"},
        {code: "fullDate", value: "Fecha Completa"},
        {code: "time", value: "Hora"},
        {code: "email", value: "Correo"},
        {code: "boolean", value: "Valor Boleano"}
    ];

    constructor(private http: CustomHttp) {
    }

    /**
     * Envia una petición a WS para guardar autorizacion
     */
    saveField(camposExtra: CamposExtra): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, camposExtra)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un autorizacion
     */
    getField(idTicketField: number): Observable<CamposExtra> {
        return this.http.sendRequest(this.GET_CODE, {}, idTicketField)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de autorizacion
     */
    updateField(camposExtra: CamposExtra): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, camposExtra, camposExtra.idTicketField)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de autorizacion
     */
    deleteField(idTicketField: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idTicketField)
            .catch(error => this.http.handleError(error));
    }

    findByCategory(params?: any): Observable<Array<CamposExtra>> {
        return this.http.sendRequest(this.GET_BY_CATEGORY, params)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<CamposExtra>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class CamposExtra {
    public idTicketField: number;
    public active: boolean = true;
    public key: string;
    public legend: string;
    public fieldType: string;
    public fieldValidation: string;
    public createdDate: string;
    public validationMessage: string;
    public categoryView: Categoria = new Categoria();
}
